import { createReducer } from "@reduxjs/toolkit";
import { StepsEnum } from "layout/enums/step.enum";
import { Step } from "layout/models/step.model";
import {
	layoutEndStep,
	layoutSetCurrentPraticaState,
	layoutSetHighStep,
	layoutSetSteps,
	layoutUpdateStepsByService,
} from "./actions";

export interface LayoutReducerType {
	steps: Step[] | undefined;
	endSteps: boolean;
	higherStep: Step | undefined;
	currentPraticaState: Step[] | undefined;
}

const initialState: LayoutReducerType = {
	steps: undefined,
	endSteps: false,
	higherStep: undefined,
	currentPraticaState: undefined,
};

export const layoutReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(layoutSetSteps, (state, action) => {
			state.steps = action.payload;
		})
		.addCase(layoutUpdateStepsByService, (state, action) => {
			if (action?.payload) {
				let tipoServizio = action?.payload;

				state.steps = state.steps?.map((step) => {
					if (step.id != StepsEnum.SERVIZI) return step;

					return {
						...step,
						subSteps: step.subSteps?.filter((ss) => ss.tipoServizi?.includes(tipoServizio)),
					};
				});
			}
		})
		.addCase(layoutEndStep, (state, action) => {
			state.endSteps = action.payload;
		})
		.addCase(layoutSetHighStep, (state, action) => {
			let higherStep = action.payload;

			if (state.higherStep) {
				let oldIndex =
					state?.steps?.findIndex(
						(s) =>
							s?.route == state.higherStep?.route ||
							s?.subSteps?.find((ss) => ss?.route == state.higherStep?.route)
					) || 0;

				let newIndex =
					state?.steps?.findIndex(
						(s) =>
							s?.route == action.payload?.route ||
							s?.subSteps?.find((ss) => ss?.route == action.payload?.route)
					) || 0;

				if (oldIndex > newIndex) higherStep = state.higherStep;
			}

			state.higherStep = higherStep;
		})
		.addCase(layoutSetCurrentPraticaState, (state, action) => {
			state.currentPraticaState = action.payload;
		});
});
